import React, { Fragment } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';

import Abstract from '../helpers/base/abstract_base';

class AppContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        //<Route component={Abstract} {...props} />
        // <Route path='/login/' component={LoginPage}/>
        // <AppContainer>
        //     <Route
        //         render={(props) => (
        //             auth.loggedIn() ?
        //                 (<Abstract {...props}/>) :
        //                 (<Redirect to="/login/" />)
        //         )}
        //     />
        // </AppContainer>
        return (
            <div id='wrapper' {...this.props}>
                {this.props.children}
            </div>
        );
    }
}

AppContainer.propTypes = {
    children: PropTypes.node,
};

const AppRouter = () => (
    <BrowserRouter>
        <Fragment>
            <Switch>
                <AppContainer>
                    <Route
                        render={(props) => (<Abstract {...props}/>)}
                    />
                </AppContainer>
            </Switch>
        </Fragment>
    </BrowserRouter>
);

export { AppRouter };



// WEBPACK FOOTER //
// ./src/components/routers/AppRouter.js